import { atom } from 'recoil';

export const isBannerVisible = atom<boolean | null>({
  key: 'isBannerVisible',
  default: true,
});
